// extracted by mini-css-extract-plugin
export default {"image-container":"QuestionImage_image-container__Byrnu","image":"QuestionImage_image__D3odb","image1":"QuestionImage_image1__SfxMg","image2":"QuestionImage_image2__wAhKL"};